import Nav from '../Nav'

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Nav />
      <div className="app-main-typography">{children}</div>
    </>
  )
}
